import { isEmptyString } from '../../predicates/string';
import { isUndefined } from '../../predicates/type';
import {
	formatDecimalScale,
	hasNumericNegativeSignOnly,
	hasTrailingZeros,
	isStrictNumber,
	removeTrailingZeros,
	toNumber,
} from '../../utils/number';
import { NumberTextboxProps } from './types';

export const normalizeValueOnBlur = (
	value: string,
	options: Pick<NumberTextboxProps, 'allowNegativeValue' | 'allowComma'>,
) => {
	let newValue = value;

	if (options.allowComma && hasTrailingZeros(newValue)) {
		newValue = removeTrailingZeros(newValue);
	}

	if (newValue.match(/[,.]$/)) {
		newValue = newValue.slice(0, -1);
	}

	if (options.allowNegativeValue && hasNumericNegativeSignOnly(newValue)) {
		newValue = '';
	}

	if (isEmptyString(newValue)) {
		return newValue;
	}

	const parsedNewValue = toNumber(newValue);

	return isStrictNumber(parsedNewValue) ? parsedNewValue : newValue;
};

export const formatValueOnBlur = (value: string | number, options: Pick<NumberTextboxProps, 'decimalScale'>) => {
	let newValue: string | number = String(value);

	if (isEmptyString(newValue)) {
		return value;
	}

	if (!isUndefined(options.decimalScale)) {
		newValue = formatDecimalScale(value, options.decimalScale);
	}

	return newValue;
};
